export const TabPersonlizacao = () => {
  return <div>Conteúdo da aba Personalização</div>;
};
